(function() {
	'use strict';

	angular
		.module('diplomaApp')
		.controller('introductionController', ['$scope', '$http', '$location', '$log', '$filter', '$timeout', 'dpText', 'dpHelper', introductionController]);

	function introductionController($scope, $http, $location, $log, $filter, $timeout, dpText, dpHelper)
	{
		$scope.formData = {
			count: 1,
			list_count_content: 0,
			list_count_attach: 0,
			paper_content: '1',
			paper_attach: '1',
			print_mode_content: 'combi',
			print_mode_attach: 'combi',
			paper_mode_content: '1',
			paper_mode_attach: '1',
		};

		$scope.papers= {};
		$scope.minCount = 1;
		$scope.time = new Date().getTime();

		// funkcie
		$scope.checkVoucher = checkVoucher;
		$scope.removeVoucher = removeVoucher;
		$scope.removePdf = removePdf;

		function initialize() {
			$http.post('/diplomovky/fast_ajax/getIntroductionData')
				.then(
					function successCallback(response) {
						$scope.sessionData = response.data.sessionData;
						$scope.bindings = response.data.bindings;
						setDefaults($scope.sessionData);
						$scope.txt = response.data.texts;
						dpText.set($scope.txt);
						dpHelper.step = response.data.step;
						$scope.dpHelper = dpHelper;

						$scope.papers = response.data.papers;
						$scope.contentFile = $scope.sessionData.content_file;
						$scope.attachFile = $scope.sessionData.attach_file;
						$scope.paper_content = $scope.sessionData.paper_content;
						$scope.attach_content = $scope.sessionData.attach_content;

						$scope.voucher = dpHelper.getVoucherData($scope.sessionData);

						$scope.minCount = dpHelper.getMinimumCount($scope.voucher, $scope.minCount, $scope.formData.count);
						checkMinimumCount();

						var sessionId = response.data.sessionData.session_id;
						$scope.bindingColors = response.data.bindingColors;
						$scope.bindingFontColors = response.data.bindingFontColors;
						$scope.bindingBackColors = response.data.bindingBackColors;

						initUpload('content', '#upload-content-button-1', sessionId);
						initUpload('content', '#upload-content-button-2', sessionId);
						initUpload('attach', '#upload-attach-button-1', sessionId);
						initUpload('attach', '#upload-attach-button-2', sessionId);

						refreshSelectpicker();

						//čakáme aby za zmenu nepovažovalo setDefaults()
						$timeout(function(){
							$scope.$watch('formData.binding_processing', bindingProcessingWatch);
							$scope.$watch('formData.payment_mode', refreshPriceDataWatch);
							$scope.$watch('formData.binding', refreshPriceDataWatch);
							$scope.$watch('formData.binding', refreshBindingProcessingWatch);
							$scope.$watch('formData.binding', changeBinding);
							$scope.$watch('formData.count', refreshPriceDataWatch);
							$scope.$watch('formData.print_mode_content', refreshPriceDataWatch);
							$scope.$watch('formData.print_mode_attach', refreshPriceDataWatch);
							$scope.$watch('formData.paper_mode_content', refreshPriceDataWatch);
							$scope.$watch('formData.paper_mode_attach', refreshPriceDataWatch);
							$scope.$watch('formData.paper_content', refreshPriceDataWatch);
							$scope.$watch('formData.paper_attach', refreshPriceDataWatch);
							$scope.$watch('formData.list_count_content', listCountWatch);
							$scope.$watch('formData.list_count_attach', listCountWatch);
							$scope.$watch('formData.payment_mode_pult', changePaymentModeWatch);
						});

						if ($scope.sessionData.id_vp) {
							dpHelper.refreshPriceData($scope.formData);
						}

						function listCountWatch(newValue, oldValue) {
							if (newValue !== oldValue) {
								Session.set('updateDiplomaBack', '1');
							}

							refreshPriceDataWatch(newValue, oldValue);
						}

						function refreshBindingProcessingWatch() {
							if ($scope.formData.binding === 'termo') {
								$scope.formData.binding_processing = 'complete';
							}

							refreshSelectpicker();
						}

						function changeBinding(newValue, oldValue) {
							if (newValue !== oldValue) {
								delete $scope.sessionData.svg_editor;
								delete $scope.sessionData.binding_color_id;
								delete $scope.sessionData.binding_back_color_id;
								delete $scope.sessionData.binding_font_color_id;
                                delete $scope.sessionData.text_lines_count;

								delete $scope.formData.svg_editor;
								delete $scope.formData.binding_color_id;
								delete $scope.formData.binding_back_color_id;
								delete $scope.formData.binding_font_color_id;
                                delete $scope.formData.text_lines_count;

								setTimeout(function () {
									Session.unset('svg_editor');
									Session.unset('binding_color_id');
									Session.unset('binding_back_color_id');
									Session.unset('binding_font_color_id');
								}, 500);
							}
						}

						function changePaymentModeWatch(newValue, oldValue) {
							if (newValue !== oldValue) {
								if ($scope.formData.payment_mode === 'eshop' && newValue === 1) {
									Session.set('payment_mode', 'predajna', function () {
										$scope.formData.payment_mode = 'predajna';
										dpHelper.refreshPriceData($scope.formData);
									});
								} else if ($scope.formData.payment_mode === 'predajna' && newValue === 0) {
									Session.set('payment_mode', 'eshop', function () {
										$scope.formData.payment_mode = 'eshop';
										dpHelper.refreshPriceData($scope.formData);
									});
								}
							}
						}

						function bindingProcessingWatch(newValue, oldValue) {
							if (newValue !== oldValue) {
								dpHelper.refreshPriceData($scope.formData);
							}

							if (newValue === 'complete' && oldValue === 'cover_only') {
								if ($scope.contentFile) {
									$scope.formData.list_count_content = $scope.contentFile.pages.count;
								} else {
									$scope.formData.list_count_content = 0;
								}

								if ($scope.attachFile) {
									$scope.formData.list_count_attach = $scope.attachFile.pages.count;
								} else {
									$scope.formData.list_count_attach = 0;
								}
							}

							if (newValue === 'cover_only') {
								$scope.formData.paper_mode_content = 1;
								$scope.formData.paper_mode_attach = 1;
							}

							if (newValue === undefined) {
								$('.module-uploadifive-button input').attr('disabled', 'disabled');
							} else {
								$('.module-uploadifive-button input').removeAttr('disabled');
							}

							refreshSelectpicker();
						}

						function refreshPriceDataWatch(newValue, oldValue) {
							if (newValue !== oldValue) {
								dpHelper.refreshPriceData($scope.formData);
							}
						}
					});
		}

		function setDefaults(session) {
			var defaults = {
				count: 'int',
				payment_mode: 'string',
				binding: 'string',
				binding_processing: 'string',
				binding_color_id: 'string',
				binding_back_color_id: 'string',
				binding_font_color_id: 'string',
				print_mode_content: 'string',
				paper_mode_content: 'string',
				paper_content: 'string',
				print_mode_attach: 'string',
				paper_mode_attach: 'string',
				paper_attach: 'string',
				list_count_content: 'int',
				list_count_content_color: 'string',
				list_count_content_mono: 'string',
				list_count_attach_color: 'string',
				list_count_attach_mono: 'string',
				list_count_attach: 'int',
			};

			for (var key in defaults) {
				var type = defaults[key];
				var value = session[key];

				if (typeof value === 'undefined') {
					continue;
				}

				if (type === 'int') {
					value = parseInt(value);
				}

				$scope.formData[key] = value;
			}
		}

		function checkMinimumCount() {
			if ($scope.formData.count < $scope.minCount || !$scope.formData.count) {
				$scope.formData.count = $scope.minCount;
				Alert.alert(dpText.get('DP_NAVYSILI_SME_POCET_KUSOV_VOUCHER'));
			}
		}

		function checkVoucher() {
			var voucher = $filter('trim')($scope.voucher_code);
			var ajaxName = 'checkVoucher';

			$.get('/module/checkVoucherType/'+voucher, function(voucher_type){
				//console.log(voucher_type);
				if(voucher_type == 'benefit')
				{
					Session.set('payment_mode', 'benefit', function() {
						ajaxName = 'checkBenefitVoucher';
						$scope.formData.payment_mode = 'benefit';
						addVoucher(voucher, ajaxName);
					});
				}
				else if(voucher_type === 'zlavomat')
				{
					Session.set('payment_mode', 'voucher', function() {
						ajaxName = 'checkVoucher';
						$scope.formData.payment_mode = 'voucher';
						addVoucher(voucher, ajaxName);
					});
				}
				else if(voucher_type === 'zlavadna' || voucher_type === 'boomer')
				{
					Session.set('payment_mode', 'voucher', function() {
						ajaxName = 'checkVoucher';
						$scope.formData.payment_mode = 'voucher';
						zlavaDnaPsw(voucher, function(voucher, secret){
							addVoucher(voucher, ajaxName, secret);
						});
					});
				}
				else if(voucher_type == 'faxac')
				{
					Session.set('payment_mode', 'fx_voucher', function() {
						ajaxName = 'checkFaxcopyVoucher';
						$scope.formData.payment_mode = 'fx_voucher';
						addVoucher(voucher, ajaxName);
					});
				}
				else
				{
					Alert.alert(voucher_type);
				}
			});
		}

		function addVoucher(voucher, ajaxName, secret) {
			Alert.loader(true);

			if (voucher) {
				$http.post('/diplomovky/fast_ajax/'+ajaxName, $.param({voucher: voucher, secret: secret}))
					.then(
						function successCallback(response) {
							var voucherData = response.data;

							if ($scope.formData.payment_mode === 'benefit') {
								if (voucherData.result === 0) {
									Alert.alert(voucherData.message);
								} else {
									Alert.alert(voucherData.vouchers_data[voucherData.vouchers[0]].message);
									$scope.voucher = voucherData;
								}
							} else {
								$scope.voucher = voucherData;
							}

							$scope.voucher_code = '';

							$scope.minCount = dpHelper.getMinimumCount($scope.voucher, $scope.minCount, $scope.formData.count);
							checkMinimumCount();


							//pri zľavomate je možnosť si zvoliť väzbu
							if (voucherData.db_row && voucherData.db_row.BINDING) {
								$scope.formData.binding = voucherData.db_row.BINDING;
								refreshSelectpicker();
							}

							//pri Faxcopy predaj je daná väzba foilxpress
							if ($scope.formData.payment_mode === 'fx_voucher') {
								$scope.formData.binding = 'foilxpress';
								refreshSelectpicker();
							}

							Alert.loader(false);

							errorVoucher(voucher, voucherData);
						},
						function errorCallback(response) {
							console.log(response.data);
						}
					);
			} else {
				$log.warn('Voucher musí byť neprázdny.');
				Alert.loader(false);
			}
		}

		function errorVoucher(voucher, voucherData) {
			if (voucherData.error && voucherData.error_code == 7) {

				$http.post('/diplomovky/fast_ajax/getCartItemFromVoucher', $.param({voucher: voucher}))
					.then(
						function successCallback(response) {
							var orderData = response.data;
							var ajaxName = 'removeVoucher';

							if ($scope.formData.payment_mode === 'fx_voucher') {
								ajaxName = 'removeFaxcopyVoucher';
							}

							if ($scope.formData.payment_mode === 'benefit') {
								ajaxName = 'removeBenefitVoucher';
							}

							var confirm_text = Text.assignRewrite(voucherData.error, {
								'nazov_objednavky': orderData.NAZOV,
								'datum_objednavky': orderData.DATE_CREATED,
							});

							Alert.confirm(confirm_text, function(){
								$.post('/diplomovky/fast_ajax/removeFromCart', {main_id: orderData.MAIN_ID}, function(data) {
									$.post('/diplomovky/fast_ajax/'+ajaxName, {voucher: voucher}, function() {
										$scope.voucher_code = voucher;
										checkVoucher();
									});
								});
							});
						});
			} else if (voucherData.error) {
				Alert.alert(voucherData.error);
			} else {
				dpHelper.refreshPriceData($scope.formData);
			}
		}

		function removeVoucher(voucher, onRemove) {
			var ajaxName = 'removeVoucher';

			if ($scope.formData.payment_mode === 'fx_voucher') {
				ajaxName = 'removeFaxcopyVoucher';
			}

			if ($scope.formData.payment_mode === 'benefit') {
				ajaxName = 'removeBenefitVoucher';
			}

			$http.post('/diplomovky/fast_ajax/'+ajaxName, $.param({voucher: voucher}))
				.then(
					function successCallback(response) {
						var voucher = response.data;
						$scope.voucher = voucher;

						$scope.minCount = dpHelper.getMinimumCount($scope.voucher, $scope.minCount, $scope.formData.count);
						checkMinimumCount();
						dpHelper.refreshPriceData($scope.formData);

						if ($scope.voucher === "") {
							refreshSelectpicker();

							Session.set('payment_mode', 'eshop', function() {
								$scope.formData.payment_mode = 'eshop';
							});
						}

						if (typeof onRemove === 'function') {
							onRemove();
						}
					},
					function errorCallback(response) {
						console.log(response.data);
					}
				);
		}

		function removePdf(type) {
			$http.post('/diplomovky/fast_ajax/removePdf/' + type).then(function(){
				delete $scope[type + 'File'];
				$scope.formData['list_count_' + type] = 0;
			});
		}

		/**
		 * @param  {string} type content|attach
		 */
		function initUpload(type, selector, sessionId) {

			$(selector).uploadifive({
	            'uploadScript': '/diplomovky/fast_ajax/uploadPdf/'+type,
	            'buttonText': $scope.txt.DP_NAHRAT,
	            'fileType': ['application/pdf', 'application/x-download'],
	            'auto': true,
	            'multi': false,
	            'buttonClass': 'btn btn-success',
	            'removeCompleted': true,
	            'formData': {
	                'session_id': sessionId
	            },
	            onUpload: function(filesToUpload) {
	            	var html = '<div class="progress">';
	            	html += '<div class="progress-bar progress-bar-striped active progress-upload-file" role="progressbar" style="width: 0%">';
	            	html += '<span class="sr-only">45% Complete</span>';
	            	html += '</div>';
	            	html += '</div>';

	            	console.log(filesToUpload);

	            	Alert.loader(true, dpText.get('DP_VAS_SUBOR_SA_NAHRAVA') + html);
	            },
	            'onAddQueueItem' : function(file) {
		            console.log(file);
		        },
	            onUploadComplete: function(file, json_data) {
	            	var data = JSON.parse(json_data);

	            	if (data.error) {
	            		Alert.alert(data.error);
	            	} else {
	            		$scope.$apply(function () {
	            			if (data.type) {
	            				$scope.time = new Date().getTime();
	            				$scope[data.type + 'File'] = data;
	            				$scope.formData['list_count_'+data.type] = data.pages.count;
	            				$scope.formData['list_count_' + data.type + '_color'] = data.pages.co;
	            				$scope.formData['list_count_' + data.type + '_mono'] = data.pages.bw;
	            			}
				        });
	            	}

	            	Alert.loader(false);
	            },
	            onUploadError: function(error) {
	                console.log(error);
	            },
	            onError: function(errorType) {
	            	console.log(errorType);
	            	if (errorType == 'FORBIDDEN_FILE_TYPE') {
	            		Alert.alert(dpText.get('DP_1_UPLOAD_TXT_NEPLATNY_TYP_SUBORU'));
	            		setTimeout(function(){
	            			Alert.loader(false);
	            		}, 300);
	            	}


	            },
				onInit: function() {
					$('.uploadifive-button').each(function(index, el) {
						var $button = $(this).find('button[title]');

						if ($button.length) {
							var title = $button.attr('title');
							$(this).attr('title', title).tipTip();
						}
					});
					$('.uploadifive-button').removeAttr('style').removeClass('uploadifive-button').addClass('module-uploadifive-button');
				},
				onProgress: function(file, e) {
		            if (e.lengthComputable) {
		                var percent = Math.round((e.loaded / e.total) * 100);

		            	$('.progress-upload-file').css('width', percent+'%');
		            	$('.progress-upload-file').html(percent+' %');

		            	if (percent == 100) {
		            		Alert.loader(false);
		            		Alert.loader(true, dpText.get('DP_POCKAJTE_KYM_SA_SPRACUJE_SUBOR'));
		            	}
		            }
		        }
	        });
		}

		function refreshSelectpicker() {
			//timeout sa spustí až po renderi viewu
			$timeout(function() {
		    	$('select').selectpicker('refresh');
			});
		}

		/*
			Initialize
		 */
		angular.element(document).ready(function () {
			initialize();
	    });
	}
}());
